import { RunFacetField } from '../../../types/schema';
import { FEEDBACK_VALUE_KEY } from '../constants';

/**
 * Formats a facet value for display based on the facet key type.
 *
 * @param facet - The facet object containing key and value
 * @param keepRawValue - Whether to keep the raw value without formatting
 * @returns The formatted value string or number
 */

export function formatFacetValue(
  facet: RunFacetField,
  keepRawValue: boolean
): string | number {
  const { key, value } = facet;

  // Handle feedback key score - extract numeric value after ' == '
  if (key === 'feedback_key_score') {
    return +value.split(' == ')[1];
  }

  // Handle feedback value - extract value after ' == ' and remove quotes
  if (key === FEEDBACK_VALUE_KEY) {
    return value.split(' == ')[1].replace(/^['"]|['"]$/g, '');
  }

  // If keepRawValue is true, return the value as-is
  if (keepRawValue) {
    return value;
  }

  // Default formatting - replace underscores with spaces
  return value.replace(/_/g, ' ');
}
